import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchCinema } from '../api/endpoints';
import TopBar from '../components/TopBar';
import Splash from '../components/Splash';
import { copyToClipboard, hapticNotify } from '../lib/tg';
import { useState } from 'react';

export default function CinemaDetail() {
  const { id } = useParams();
  const { data, isLoading } = useQuery({
    queryKey: ['cinema', id],
    queryFn: () => fetchCinema(id!),
    enabled: !!id,
  });
  const [copied, setCopied] = useState(false);

  if (isLoading || !data) return <Splash />;

  const mapsUrl = data.address
    ? `https://yandex.ru/maps/?text=${encodeURIComponent(data.address)}`
    : null;

  function onCopy() {
    if (!data?.address) return;
    copyToClipboard(data.address);
    hapticNotify('success');
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }

  return (
    <div className="min-h-screen pb-8">
      <TopBar title={data.name} />
      <div className="px-4 pt-3 space-y-3">
        <div className="card p-4">
          <div className="text-xs text-muted mb-1">Кинотеатр</div>
          <div className="text-xl font-semibold">{data.name}</div>
        </div>

        {data.address && (
          <div className="card p-4">
            <div className="text-xs text-muted mb-1">Адрес</div>
            <div className="text-base mb-3">{data.address}</div>
            <div className="grid grid-cols-2 gap-2">
              <button className="btn-secondary text-sm" onClick={onCopy}>
                {copied ? 'Скопировано' : 'Копировать'}
              </button>
              {mapsUrl && (
                <a
                  href={mapsUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-secondary text-sm text-center"
                >
                  Открыть на карте
                </a>
              )}
            </div>
          </div>
        )}

        {data.description && (
          <div className="card p-4">
            <div className="text-xs text-muted mb-1">О кинотеатре</div>
            <div className="text-sm whitespace-pre-wrap leading-relaxed">{data.description}</div>
          </div>
        )}
      </div>
    </div>
  );
}
